import Chip, { ChipProps } from "@mui/material/Chip";

import { useMemo } from "react";

import { useTheme } from "react-admin";

import { mapDeviceTypeToDisplay } from "common";
import { bluePalette, darkPalette, orangePalette, purplePalette, violetPalette } from "theme";
import { anchorType, AnyString, assetType, DeviceType } from "types";

export type DeviceChipProps = Omit<ChipProps, "color" | "label"> & { type: DeviceType | AnyString };

export const DeviceChip = ({ type, ...props }: DeviceChipProps) => {
  const [theme] = useTheme();
  const isDark = theme === "dark";

  const styles = useMemo(() => {
    switch (type) {
      case "Physical":
      case assetType.Physical:
      case "Tag":
      case anchorType.Luna:
        return isDark ? darkPalette.purplePalette : purplePalette;
      case "Mobile":
      case assetType.Mobile:
        return isDark ? darkPalette.bluePalette : bluePalette;
      case "Asset":
        return isDark ? darkPalette.violetPalette : violetPalette;
      case "Wi-Fi":
      case "Wi-Fi AP":
      case "Anchor":
      case anchorType.Wifi:
      case "Luna Device":
      case anchorType.Gateway:
        return isDark ? darkPalette.orangePalette : orangePalette;
      default:
        return {};
    }
  }, [isDark, type]);

  return (
    <Chip
      {...props}
      label={mapDeviceTypeToDisplay(type)}
      size="small"
      sx={{
        textTransform: "capitalize",
        ...styles
      }}
    />
  );
};
